import toast from 'react-hot-toast';
import assignmentAttachmentServices from 'ApiService/Placement/assignmentAttachmentServices';

const FILE_BASE = process.env.REACT_APP_API_BASE_URL;

const AttachmentPreview = ({ attachment, onDelete, isHR }) => {
  const fileUrl = `${FILE_BASE}${attachment.url}`;
  const isNotesOnly = attachment.filename?.startsWith('notes-') && attachment.filename?.endsWith('.txt') && attachment.notes;

  const handleDelete = async () => {
    if (!window.confirm('Delete this attachment?')) return;
    try {
      const res = await assignmentAttachmentServices.deleteAttachment(attachment._id);
      if (res.data.success) {
        toast.success('Deleted');
        onDelete(attachment._id);
      }
    } catch {
      toast.error('Failed to delete');
    }
  };

  const icon = {
    image: '📷',
    voice: '🎙',
    video: '🎥',
    document: '📎',
  }[attachment.type] || '📄';

  if (isNotesOnly) {
    return (
      <div className="group flex items-start gap-2">
        <div className="min-w-0 flex-1 rounded-xl bg-brand-50 px-4 py-2.5 text-sm text-gray-800 dark:bg-navy-600 dark:text-gray-100">
          <p className="whitespace-pre-wrap">{attachment.notes}</p>
        </div>
        {isHR && (
          <button onClick={handleDelete} className="mt-1 shrink-0 text-gray-400 hover:text-red-500" title="Delete">
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-start gap-3 rounded-lg border border-gray-200 p-3 dark:border-white/10">
      <span className="mt-1 text-xl">{icon}</span>
      <div className="min-w-0 flex-1">
        {attachment.type !== 'voice' && attachment.type !== 'image' && (
          <p className="truncate text-sm font-medium text-gray-800 dark:text-gray-200">
            {attachment.filename}
          </p>
        )}
        {attachment.notes && (
          <p className="mt-0.5 text-xs text-gray-500">{attachment.notes}</p>
        )}

        {attachment.type === 'image' && (
          <img src={fileUrl} alt="" className="mt-2 max-h-48 w-full max-w-full rounded object-contain" />
        )}
        {attachment.type === 'voice' && (
          <audio controls className="mt-2 w-full">
            <source src={fileUrl} type={attachment.mimeType} />
          </audio>
        )}
        {attachment.type === 'video' && (
          <video controls className="mt-2 max-h-48 w-full rounded">
            <source src={fileUrl} type={attachment.mimeType} />
          </video>
        )}
        {attachment.type === 'document' && (
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-1 inline-block rounded bg-brand-500 px-3 py-1 text-xs text-white hover:bg-brand-600"
          >
            View / Download
          </a>
        )}
      </div>
      {isHR && (
        <button onClick={handleDelete} className="shrink-0 text-gray-400 hover:text-red-500" title="Delete">
          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default AttachmentPreview;